sessionStorage.setItem('logoUrl',res.data.data.logoUrl)<template>
  <el-form :model="loginInfo" :rules="rules2" ref="loginInfo" label-position="left" label-width="0px"
           class="demo-ruleForm login-container">
    <h3 class="title">系统登录</h3>
    <el-form-item prop="mhManagerAccount">
      <el-input type="text" v-model.trim="loginInfo.mhManagerAccount" placeholder="账号"><!--auto-complete="new-password"-->
      </el-input>
    </el-form-item>
    <el-form-item prop="mhManagerPassword">
      <el-input type="password" v-model="loginInfo.mhManagerPassword" @keyup.enter.native="handleSubmit2"
                 placeholder="密码"><!--auto-complete="new-password"-->
      </el-input>
    </el-form-item>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2('loginInfo')" :loading="logining">登录
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import * as getData from '../service/getData';
  import * as global from '../config/mUtils'

  export default {
    data() {
      let isAccountCorrect = (rule, value, callback) => {
        const myReg = /^\S+$/;
        if (!value) {
          return callback(new Error('账号不能为空！'))
        }
        if (!myReg.test(value)) {
          return callback(new Error('账号不能包含空白字符！'))
        } else {
          callback()
        }
      };
      let isTypeCorrect = (rule, value, callback) => {
        const myReg = /^\S+$/;
        if (!value) {
          return callback(new Error('密码不能为空！'))
        }
        if (!myReg.test(value)) {
          return callback(new Error('密码不能包含空白字符！'))
        } else {
          callback()
        }
      };
      return {
        logining:false,
        loginInfo:{
          mhManagerAccount:'',
          mhManagerPassword:'',
        },
        channelId:1,
        permissions:[],
        rules2:{
          mhManagerAccount: [
            {required: true, validator: isAccountCorrect, trigger: 'blur'},
          ],
          mhManagerPassword: [
            {required: true, validator: isTypeCorrect, trigger: 'blur'},
          ]
        },
      };
    },
    mounted() {
      let url = window.location.origin +'/'
      // let url = test-mh-company.test176.cn;
      getData.getChannelIdByUrl(url).then( res =>{
        sessionStorage.setItem('channelId', res.data.channelId);
        this.channelId = res.data.channelId
      })
    },
    methods: {
      handleSubmit2(){
        this.logining = true
        this.$refs.loginInfo.validate((valid) => {
          if (valid) {
            getData.login(this.loginInfo.mhManagerAccount,this.loginInfo.mhManagerPassword,this.channelId).then(res => {
              if(res.data.code == 'success'){
                this.$message({
                  message: '登录成功',
                  type: 'success'
                });
                sessionStorage.setItem('permissions', JSON.stringify(res.data.data.permissions))
                sessionStorage.setItem('allSessionId', res.data.data.allSessionId)
                sessionStorage.setItem('companyId', res.data.data.companyId)
                this.$router.push('/workbench')
                this.logining = false
              }
              else{
                this.$message({
                  message: res.data.message,
                  type: 'error'
                });
                this.logining = false
              }
            })
          } else {
            console.log('error submit!!');
            this.logining = false
            return false;
          }
        });
      },
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Login.vue